<div class="modal-content">
  <div class="modal-header">
    <h4 class="modal-title">{{ 'Add categorization' | translate }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="onClose()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col">
        <form
          novalidate
          (ngSubmit)="onSave()"
          [formGroup]="documentCategoryForm"
        >
          <div class="form-group">
            <label for="amount" class="control-label">{{
              'Amount' | translate
            }}</label>
            <input
              #documentCategoryAmount
              type="text"
              class="form-control"
              tabindex="0"
              id="amount"
              [class.is-invalid]="
                sent &&
                (documentCategoryForm.get('amount').hasError('required') ||
                  documentCategoryForm.get('amount').hasError('notZero'))
              "
              formControlName="amount"
            />

            <span
              class="invalid-feedback"
              *ngIf="
                sent && documentCategoryForm.get('amount').hasError('required')
              "
            >
              {{ 'global.validators.required.error' | translate }}</span
            >

            <span
              class="invalid-feedback"
              *ngIf="
                sent && documentCategoryForm.get('amount').hasError('notZero')
              "
            >
              {{ 'Invalid value' | translate }}</span
            >
          </div>

          <div class="form-group">
            <label for="note" class="control-label">{{
              'Category' | translate
            }}</label>
            <select
              class="form-control"
              [class.is-invalid]="
                sent &&
                documentCategoryForm.get('categoryId').hasError('required')
              "
              formControlName="categoryId"
            >
              <option [value]="null">{{ 'global.select.please-select' | translate }}</option>
              <option *ngFor="let cat of categories" [value]="cat.id">
                {{ cat.name }}
              </option>
            </select>

            <span
              class="invalid-feedback"
              *ngIf="
                sent &&
                documentCategoryForm.get('categoryId').hasError('required')
              "
            >
              {{ 'global.validators.required.error' | translate }}</span
            >
          </div>

          <!-- Date -->
          <div class="form-group">
            <label for="date" class="control-label">
              {{ 'Date' | translate }}
            </label>
            <div class="input-group">
              <input
                tabindex="-1"
                class="form-control"
                readonly
                name="date"
                formControlName="date"
                ngbDatepicker
                #d="ngbDatepicker"
                placement="bottom-right"
              />

              <div class="input-group-append">
                <button
                  tabindex="0"
                  class="btn btn-light input-group-text"
                  (click)="d.toggle()"
                  type="button"
                >
                  <i class="fe fe-sm fe-calendar"></i>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button
      class="btn btn-outline-secondary"
      type="button"
      (click)="onClose()"
      [disabled]="loading"
    >
      {{ 'Cancel' | translate }}
    </button>
    <button
      class="btn btn-primary"
      type="button"
      (click)="onSave()"
      [disabled]="loading"
    >
      <span *ngIf="!documentCategory || !documentCategory.id">{{
        'global.save' | translate
      }}</span>
      <span *ngIf="documentCategory && documentCategory.id">{{
        'Update' | translate
      }}</span>
      <span *ngIf="loading"
        >&nbsp; <i class="fa fa-spinner-third fa-spin fa-md fa-lg"></i
      ></span>
    </button>
  </div>
</div>
